function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.868 6.748h-.288v-2a4.084 4.084 0 1 0-8.164 0v2h-.232A1.164 1.164 0 0 0 3.02 7.912v5.848a1.164 1.164 0 0 0 1.164 1.164h8.684c.643 0 1.164-.521 1.164-1.164V7.912c0-.643-.521-1.164-1.164-1.164zm-7.652-2a3.284 3.284 0 1 1 6.564 0v2H5.216v-2zm8 9a.364.364 0 0 1-.364.364H4.184a.364.364 0 0 1-.364-.364V7.912c0-.201.163-.364.364-.364h8.684c.201 0 .364.163.364.364l-.016 5.836z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.628 9.052a1.256 1.256 0 0 0-.5 2.4v.608a.5.5 0 1 0 1 0v-.6a1.256 1.256 0 0 0-.5-2.4v-.008z"
}));
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.614edbee.svg";
export { ForwardRef as ReactComponent };